import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ko from '@/locales/ko'
import en from '@/locales/en'
import zh from '@/locales/zh'
import ja from '@/locales/ja'
Vue.use(VueI18n)

export const SUPPORTED_LOCALES = ['ko', 'en', 'zh', 'ja']

const messages = { ko, en, zh, ja }
const STORAGE_KEY = 'APP_LOCALE'

function resolveInitialLocale () {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (saved && SUPPORTED_LOCALES.indexOf(saved) !== -1) {
      return saved
    }
  } catch (e) { /* ignore */ }

  return 'en'
}

const initialLocale = resolveInitialLocale()

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLocale
}

export default i18n
